import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ChatLauncherComponent } from './chat-launcher.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    ChatLauncherComponent
  ],
  exports: [
    ChatLauncherComponent
  ]
})
export class ChatLauncherModule {
}
